
export default function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function getSalePrice(item) {
  let itemPrice = ""

  if (item.listingInfo[0].hasOwnProperty("buyItNowPrice")) {
    itemPrice = item.listingInfo[0].buyItNowPrice[0].__value__
  } else {
    itemPrice = item.sellingStatus[0].currentPrice[0].__value__
  }

  let priceSplits = itemPrice.split(".")
  if (priceSplits[1].length === 1) {
    priceSplits[1] = `${priceSplits[1]}0`
  }
  return `$${priceSplits[0]}.${priceSplits[1]}`
}

/* export function setDateTimeFormat(stringDateTime) {
  let gmtDateTime = new Date(stringDateTime)
  let localDateTime = `${gmtDateTime.toLocaleDateString("en-US")} ${gmtDateTime.toLocaleTimeString("en-US")}`
  return localDateTime
} */
